import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	setAuthSecretCode,
	type SetAuthSecretCodeErrorResponse,
	type SetAuthSecretCodeRequest,
	type SetAuthSecretCodeResponse,
} from '../../http';

export function useSetAuthSecretCode(
	options?: UseMutationOptions<
		SetAuthSecretCodeResponse,
		AxiosError<SetAuthSecretCodeErrorResponse>,
		SetAuthSecretCodeRequest
	>,
): UseMutationResult<SetAuthSecretCodeResponse, AxiosError<SetAuthSecretCodeErrorResponse>, SetAuthSecretCodeRequest> {
	return useMutation<SetAuthSecretCodeResponse, AxiosError<SetAuthSecretCodeErrorResponse>, SetAuthSecretCodeRequest>(
		(request) => setAuthSecretCode(request).then(({data}) => data),
		options,
	);
}
